import { Icon, IconsEnum, toIconsEnum } from '../../Icons';
import { MenuItemBlock, Navigation } from '../../header/Header';
import React, { useState } from 'react';

import { AnchorLink } from '../../anchorLink';
import { LinkProps } from 'next/link';
import type { Url } from 'components/mobileTabNavigation';
import { setSelectedBet } from 'features/dashboard/myBets/myBetSlice';
import styles from './Accordion.module.scss';
import { useAppDispatch } from 'lib/centralStore';
import { useRouter } from 'next/router';

export type AccordionProps = {
  data: (Navigation | LinkProps)[];
  isOpenSetting?: number | null;
};

export const Accordion: React.FC<AccordionProps> = ({ data, isOpenSetting }: AccordionProps) => {
  const router = useRouter();
  const currentPath = router.asPath.split('?')[0];
  const dispatch = useAppDispatch();

  const [activeItem, setActiveItem] = useState<number | null>(isOpenSetting ?? null);

  const handleToggleAccordion = (index: number | null, firstSubLink?: Url, hasActiveSubLink: boolean = false) => {
    if (firstSubLink && !hasActiveSubLink) {
      router.push(firstSubLink.toString());
    }
    if (activeItem === index && hasActiveSubLink) {
      return setActiveItem(null);
    }
    setActiveItem(index);
  };

  return (
    <div className={`${styles.accordionMenu}`}>
      {data?.map(({ id, navigationItemBlock, label, icon }: Navigation & LinkProps, index) => {
        const itemBlock = navigationItemBlock![0];
        const { menuItemBlock } = navigationItemBlock![0];
        const isBonusPage = (itemBlock.href as string)?.includes('/dashboard/i-miei-bonus');
        let isActiveItem;
        if (isBonusPage) {
          const path = (itemBlock.href as string).replace('/cash', '');
          isActiveItem = currentPath.includes(path);
        } else {
          isActiveItem = currentPath === itemBlock.href;
        }
        const subLinks = menuItemBlock?.map((item) => item.linkBlock[0].href);
        const isSubLinkActive = subLinks?.includes(currentPath);
        // console.log(
        //   'menuItemBlock --------------',
        //   menuItemBlock,
        //   isSubLinkActive
        // );
        return menuItemBlock ? (
          <div key={id}>
            <button
              type="button"
              key={id}
              id={`${id}-header`}
              aria-label={label}
              aria-controls={`${id}-panel`}
              className={`${styles.itemContainer} ${
                /* activeItem === index && */ isSubLinkActive
                  ? styles.itemContainerActive
                  : styles.itemContainerInactive
              }`}
              aria-expanded={activeItem === index /* && isSubLinkActive */}
              onClick={() => handleToggleAccordion(index, menuItemBlock[0].linkBlock[0].href, true)}
            >
              <h3 className={styles.btnAccordion} key={id}>
                <Icon
                  iconId={toIconsEnum(icon![0].iconName)}
                  className={styles.icon}
                  color="var(--color-on-bg-primary)"
                />
                <span className={`${styles.item}`}>{label}</span>
                <Icon
                  iconId={IconsEnum.CHEVRON_DOWN}
                  className={`${styles.arrow} ${
                    activeItem === index /* && isSubLinkActive */ ? styles.arrowUp : styles.arrowDown
                  }`}
                  color="var(--color-on-bg-primary)"
                />
              </h3>
            </button>

            <section
              id={`${id}-panel`}
              aria-labelledby={`${id}-header`}
              hidden={activeItem !== index}
              className={`${styles.content} ${
                activeItem === index /* && isSubLinkActive */ ? styles.open : styles.close
              }`}
            >
              {menuItemBlock?.map(({ id, label, linkBlock }: MenuItemBlock) => {
                return (
                  <AnchorLink
                    key={id}
                    href={`${linkBlock[0].href}`}
                    className={`${styles.link} ${linkBlock[0].href === currentPath ? styles.activeSubLink : ''}`}
                  >
                    {label}
                  </AnchorLink>
                );
              })}
            </section>
          </div>
        ) : (
          <AnchorLink
            key={id}
            className={`${styles.itemContainer} ${
              /* activeItem === index ||  */ isActiveItem ? styles.itemContainerActive : styles.itemContainerInactive
            }`}
            href={`${navigationItemBlock![0].href}`}
          >
            <h3
              key={id}
              className={`${styles.item}`}
              onClick={() => {
                setActiveItem(index);
                dispatch(setSelectedBet(undefined));
              }}
            >
              <Icon
                iconId={toIconsEnum(icon![0].iconName)}
                className={styles.icon}
                color="var(--color-on-bg-primary)"
              />
              {label}
            </h3>
          </AnchorLink>
        );
      })}
    </div>
  );
};
